<script>
    import vulnerabilityService, {
        parseCVSS2,
        getCVSSv3items,
        getCVSSv2items,
        getCVSSv4items,
        getDecimalPart,
    } from "../service.js";
    import { format } from "svelte-i18n";

    let { vulnerability } = $props();

    const CVSS_v4_items = getCVSSv4items();
    const CVSS_v3_items = getCVSSv3items();
    const CVSS_v2_items = getCVSSv2items();
    let selected_version = $state(3);

    let cvss_data = $state({
        v2: vulnerabilityService.parseCVSSvector(vulnerability, 2),
        v3: vulnerabilityService.parseCVSSvector(vulnerability, 3),
        v4: vulnerabilityService.parseCVSSvector(vulnerability, 4),
    });

    if (vulnerability.cvss4_vector) {
        selected_version = 4;
    } else {
        if (vulnerability.cvss2_vector && !vulnerability.cvss3_vector) {
            selected_version = 2;
        }
    }
</script>

<div>
    <label for="cvss_version">{$format("vulnerability.cve_data.label")}</label>
    <select
        name="cvss_version"
        class="form-control w-25 d-inline-block"
        bind:value={selected_version}
    >
        <option value={2}>2</option>
        <option value={3}>3</option>
        <option value={4}>4</option>
    </select>
</div>
{#if selected_version == 4}
    {#if !vulnerability.cvss4_vector}
        <div class="mt-3">{$format("vulnerability.cve_data.no_data")}</div>
    {:else}
        <h5 class="mb-3 mt-5">
            <strong>{$format("vulnerability.cve_data.title")}</strong>
        </h5>
        <div class="mt-2 d-flex flex-container-2item">
            <div class="mt-3">
                <div>
                    <strong
                        >{$format("vulnerability.cve_data.att_vector")}</strong
                    >
                </div>
                <div title="">
                    {#each CVSS_v4_items.attackVector().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v4.AV == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="mt-3">
                <div>
                    <strong
                        >{$format(
                            "vulnerability.cve_data.att_requirements",
                        )}</strong
                    >
                </div>
                {#each CVSS_v4_items.attackRequirements().items as item}
                    <div
                        class="cveData-item"
                        title={item.description}
                        class:active={cvss_data.v4.AT == item.label}
                    >
                        {item.label}
                    </div>
                {/each}
            </div>
        </div>
        <div class="d-flex flex-container-2item">
            <div class="mt-3">
                <div>
                    <strong
                        >{$format("vulnerability.cve_data.complexity")}</strong
                    >
                </div>
                <div title="">
                    <div class="t-vul-complexity">
                        {#each CVSS_v4_items.attackComplexity().items as item}
                            <div
                                class="cveData-item"
                                title={item.description}
                                class:active={cvss_data.v4.AC == item.label}
                            >
                                {item.label}
                            </div>
                        {/each}
                    </div>
                </div>
            </div>

            <div class="mt-3">
                <div>
                    <strong
                        >{$format(
                            "vulnerability.cve_data.user_interaction",
                        )}</strong
                    >
                </div>
                {#each CVSS_v4_items.userInteraction().items as item}
                    <div
                        class="cveData-item"
                        title={item.description}
                        class:active={cvss_data.v4.UI == item.label}
                    >
                        {item.label}
                    </div>
                {/each}
            </div>
        </div>

        <div class="d-flex flex-container-2item">
            <div class="mt-3">
                <div>
                    <strong
                        >{$format(
                            "vulnerability.cve_data.privs_required",
                        )}</strong
                    >
                </div>
                {#each CVSS_v4_items.privilegesRequired().items as item}
                    <div
                        class="cveData-item"
                        title={item.description}
                        class:active={cvss_data.v4.PR == item.label}
                    >
                        {item.label}
                    </div>
                {/each}
            </div>
        </div>

        <div class="mt-5">
            <h5 class="mb-3 mt-3">
                <strong
                    >{$format(
                        "vulnerability.cve_data.vulnerable_system_title",
                    )}</strong
                >
            </h5>
            <div class="d-flex flex-container-2item">
                <div>
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.confidentiality",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v4_items.confidentialityImpactVulnerable().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v4.VC == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
                <div>
                    <div class="mt-3">
                        <strong
                            >{$format(
                                "vulnerability.cve_data.integrity",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v4_items.integrityImpactVulnerable().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v4.VI == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="d-flex flex-container-2item">
                <div>
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.availability",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v4_items.availabilityImpactVulnerable().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v4.VA == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <h5 class="mb-3 mt-3">
                <strong
                    >{$format(
                        "vulnerability.cve_data.subsequent_system_title",
                    )}</strong
                >
            </h5>
            <div class="d-flex flex-container-2item">
                <div>
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.confidentiality",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v4_items.confidentialityImpactSubsequent().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v4.SC == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
                <div>
                    <div class="mt-3">
                        <strong
                            >{$format(
                                "vulnerability.cve_data.integrity",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v4_items.integrityImpactSubsequent().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v4.SI == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="d-flex flex-container-2item">
                <div>
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.availability",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v4_items.availabilityImpactSubsequent().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v4.SA == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="d-flex flex-container-2item">
                <div>
                    <div class="mt-3">
                        <strong
                            >{$format(
                                "vulnerability.cve_data.vector_cvss_4",
                            )}</strong
                        >
                    </div>
                    <div class="t-vul-vector-v4">
                        {#if vulnerability.cvss_link.includes("v4")}
                            <a href={vulnerability.cvss_link} target="_blank">
                                {vulnerability.cvss3_vector ||
                                    vulnerability.cvss_vector}
                            </a>
                        {:else}
                            {vulnerability.cvss3_vector ||
                                vulnerability.cvss_vector}
                        {/if}
                    </div>
                </div>
                <div class="mt-3">
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.score",
                            )}</strong
                        >
                    </div>
                    <div class="t-vul-score-v4">
                        { vulnerability.cvss4 }
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/if}
{#if selected_version == 3}
    {#if !vulnerability.cvss3_vector}
        <div class="mt-3">{$format("vulnerability.cve_data.no_data")}</div>
    {:else}
        <h5 class="mb-3 mt-5">
            <strong>{$format("vulnerability.cve_data.title")}</strong>
        </h5>
        <div class="mt-2 d-flex flex-container-2item">
            <div class="mt-3">
                <div>
                    <strong
                        >{$format("vulnerability.cve_data.att_vector")}</strong
                    >
                </div>
                <div title="">
                    {#each CVSS_v3_items.attackVector().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v3.AV == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="mt-3">
                <div>
                    <strong
                        >{$format(
                            "vulnerability.cve_data.privs_required",
                        )}</strong
                    >
                </div>
                {#each CVSS_v3_items.privilegesRequired().items as item}
                    <div
                        class="cveData-item"
                        title={item.description}
                        class:active={cvss_data.v3.PR == item.label}
                    >
                        {item.label}
                    </div>
                {/each}
            </div>
        </div>
        <div class="d-flex flex-container-2item">
            <div class="mt-3">
                <div>
                    <strong
                        >{$format("vulnerability.cve_data.complexity")}</strong
                    >
                </div>
                <div title="">
                    <div class="t-vul-complexity">
                        {#each CVSS_v3_items.attackComplexity().items as item}
                            <div
                                class="cveData-item"
                                title={item.description}
                                class:active={cvss_data.v3.AC == item.label}
                            >
                                {item.label}
                            </div>
                        {/each}
                    </div>
                </div>
            </div>

            <div class="mt-3">
                <div>
                    <strong
                        >{$format(
                            "vulnerability.cve_data.user_interaction",
                        )}</strong
                    >
                </div>
                {#each CVSS_v3_items.userInteraction().items as item}
                    <div
                        class="cveData-item"
                        title={item.description}
                        class:active={cvss_data.v3.UI == item.label}
                    >
                        {item.label}
                    </div>
                {/each}
            </div>
        </div>

        <div class="d-flex flex-container-2item">
            <div class="mt-3">
                <div>
                    <strong>{$format("vulnerability.cve_data.scope")}</strong>
                </div>
                {#each CVSS_v3_items.scope().items as item}
                    <div
                        class="cveData-item"
                        title={item.description}
                        class:active={cvss_data.v3.S == item.label}
                    >
                        {item.label}
                    </div>
                {/each}
            </div>
        </div>

        <div class="mt-5">
            <h5 class="mt-3 mb-3">
                <strong>{$format("vulnerability.cve_data.impact")}</strong>
            </h5>
            <!--<div class="col-12 impact-graphic-container">
                <Impact />
            </div>-->
            <div class="d-flex flex-container-2item">
                <div>
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.confidentiality",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v3_items.confidentialityImpact().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v3.C == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
                <div>
                    <div class="mt-3">
                        <strong
                            >{$format(
                                "vulnerability.cve_data.integrity",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v3_items.integrityImpact().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v3.I == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="d-flex flex-container-2item">
                <div>
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.availability",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v3_items.availabilityImpact().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v3.A == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="d-flex flex-container-2item">
                <div>
                    <div class="mt-3">
                        <strong
                            >{$format(
                                "vulnerability.cve_data.vector_cvss_3",
                            )}</strong
                        >
                    </div>
                    <div class="t-vul-vector-v3">
                        {#if vulnerability.cvss_link.includes("v3")}
                            <a href={vulnerability.cvss_link} target="_blank">
                                {vulnerability.cvss3_vector ||
                                    vulnerability.cvss_vector}
                            </a>
                        {:else}
                            {vulnerability.cvss3_vector ||
                                vulnerability.cvss_vector}
                        {/if}
                    </div>
                </div>
                <div class="mt-3">
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.score",
                            )}</strong
                        >
                    </div>
                    <div class="t-vul-score-v3">
                        { vulnerability.cvss3 }
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/if}
{#if selected_version == 2}
    {#if !vulnerability.cvss2_vector}
        <div class="mt-3">{$format("vulnerability.cve_data.no_data")}</div>
    {:else}
        <h5 class="mb-3 mt-5">
            <strong>{$format("vulnerability.cve_data.title")}</strong>
        </h5>
        <div class="mt-2 d-flex flex-container-2item">
            <div class="mt-3">
                <div>
                    <strong
                        >{$format("vulnerability.cve_data.att_vector")}</strong
                    >
                </div>
                <div title="">
                    {#each CVSS_v2_items.attackVector().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v2.AV == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="mt-3">
                <div><strong>Autenticación</strong></div>
                {#each CVSS_v2_items.authentication().items as item}
                    <div
                        class="cveData-item"
                        title={item.description}
                        class:active={cvss_data.v2.Au == item.label}
                    >
                        {item.label}
                    </div>
                {/each}
            </div>
        </div>
        <div class="d-flex flex-container-2item">
            <div class="mt-3">
                <div><strong>Complejidad</strong></div>
                <div title="">
                    <div class="t-vul-complexity">
                        {#each CVSS_v2_items.attackComplexity().items as item}
                            <div
                                class="cveData-item"
                                title={item.description}
                                class:active={cvss_data.v2.AC == item.label}
                            >
                                {item.label}
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-5">
            <div class="mb-3">
                <h5>
                    <strong>{$format("vulnerability.cve_data.impact")}</strong>
                </h5>
            </div>
            <!--<div class="col-12 impact-graphic-container">
                <Impact />
            </div>-->
            <div class="d-flex flex-container-2item">
                <div>
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.confidentiality",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v2_items.confidentialityImpact().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v2.C == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
                <div>
                    <div class="mt-3">
                        <strong
                            >{$format(
                                "vulnerability.cve_data.att_vector",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v2_items.integrityImpact().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v2.I == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="d-flex flex-container-2item">
                <div>
                    <div class="mt-3">
                        <strong
                            >{$format(
                                "vulnerability.cve_data.availability",
                            )}</strong
                        >
                    </div>
                    {#each CVSS_v2_items.availabilityImpact().items as item}
                        <div
                            class="cveData-item"
                            title={item.description}
                            class:active={cvss_data.v2.A == item.label}
                        >
                            {item.label}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="d-flex flex-container-2item">
                <div class="mt-3">
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.vector_cvss_2",
                            )}</strong
                        >
                    </div>
                    <div class="t-vul-vector-v2">
                        {#if vulnerability.cvss_link.includes("v2")}
                            <a href={vulnerability.cvss_link} target="_blank">
                                {vulnerability.cvss3_vector ||
                                    vulnerability.cvss_vector}
                            </a>
                        {:else}
                            {vulnerability.cvss3_vector ||
                                vulnerability.cvss_vector}
                        {/if}
                    </div>
                </div>
                <div class="mt-3">
                    <div>
                        <strong
                            >{$format(
                                "vulnerability.cve_data.score",
                            )}</strong
                        >
                    </div>
                    <div class="t-vul-score-v2">
                        { vulnerability.cvss2 }
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/if}

<style>
    .d-flex > * {
        flex: 1;
    }
    .flex-container-2item div:first-child {
        flex: 2;
    }
    .cvss-title {
        border-top: 1px solid rgba(0, 0, 0, 0.125);
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
        margin-left: -20px;
        margin-right: -20px;
        padding: 0.75rem 1.25rem;
    }
    .cvss-title span {
        font-size: 1.1rem;
    }

    /*.impact-graphic-container {
    border: 1px solid rgba(0, 0, 0, 0.125);
    padding: 10px 25px;
}*/

    .cveData-item {
        display: inline-block;
        margin: 3px;
        padding: 2px 5px;
        border: 0;
        cursor: pointer;
        font-size: 90%;
        border-radius: 5px;
        background: #f8f9fa;
        border: 1px solid #999999;
        border-radius: 5px;
        margin-left: 0;
        cursor: auto;
    }

    .cveData-item.active {
        background: #666;
        border: 1px solid #666;
        color: #ffffff;
    }
</style>
